/// \file customFilter.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

//filtering is the array that is being filtered
//filterWith contains the filter parameters
    //logic is a string about whether the filter needs to be an and or a or
    //filters are the options of the filter.  Contains the field to check (field) the operator (contain,before,after,etc.) and the value to match with
export const CustomFilter = (filtering:any[], filterWith:{logic:string,filters:{field:string,operator:string,value:string}[]}) => {
    const tableArray = filtering;
    const filter = filterWith;
    if(filter.logic=="and"){
        const returnArray = [];
        for(let i=0;i<tableArray.length;i++){
            let good = true;
            const itemTest = tableArray[i];
            for(let j=0;j<filter.filters.length;j++){
                const filterTest = filter.filters[j];
                if(filterTest.operator=="contains"){
                    let stringTest = itemTest;
                    if(filterTest.field){
                        stringTest = itemTest[filterTest.field];
                    }
                    if(stringTest && stringTest.toLowerCase().includes(filterTest.value.toLowerCase())){
                        continue;
                    }
                    else{
                        good=false;
                        j=filter.filters.length;
                    }
                }
                else if(filterTest.operator=="oneOf"){
                    let stringTest = itemTest;
                    if(filterTest.field){
                        stringTest = itemTest[filterTest.field];
                    }
                    if(stringTest){
                        //contains at least on of them in filter test value
                        const optionList = filterTest.value.split(",");
                        let found=false;
                        for(let k=0;k<optionList.length;k++){
                            const optionTest = optionList[k];
                            if(optionTest.toLowerCase()==stringTest.toLowerCase()){
                                found=true;
                                k=optionList.length;
                            }
                        }
                        if(!found){
                            good=false;
                            j=filter.filters.length;
                        }
                    }
                    else{
                        good=false;
                        j=filter.filters.length;
                    }
                }
                else if(filterTest.operator=="after"){
                    let stringTest = itemTest;
                    if(filterTest.field){
                        stringTest = itemTest[filterTest.field];
                    }
                    if(stringTest){
                        if(stringTest!="NEVER"){
                            const filterTime = Date.parse(filterTest.value);
                            const testTime = Date.parse(stringTest);
                            if(filterTime>testTime){
                                good=false;
                                j=filter.filters.length;
                            }
                        }
                    }
                    else{
                        good=false;
                        j=filter.filters.length;
                    }
                }
                else if(filterTest.operator=="before"){
                    let stringTest = itemTest;
                    if(filterTest.field){
                        stringTest = itemTest[filterTest.field];
                    }
                    if(stringTest){
                        if(stringTest!="NEVER"){
                            const filterTime = Date.parse(filterTest.value);
                            const testTime = Date.parse(stringTest);
                            if(filterTime<testTime){
                                good=false;
                                j=filter.filters.length;
                            }
                        }
                    }
                    else{
                        good=false;
                        j=filter.filters.length;
                    }
                }
            }
            if(good){
                returnArray.push(itemTest);
            }
        }
        return returnArray;
    }
    else{//if unknown command, let everything through.  May change in the future
        console.log("error");
        return tableArray;
    }
};